<template>
    <BaseInput
        :model-value="model"
        v-bind="$attrs">
        <div class="flex gap-x-2">
            <Switch
                :id="name || label"
                v-model="model"
                :disabled="disabled"
                :name="name || label"
                class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2 dark:ring-offset-gray-800"
                :class="[model ? 'bg-primary-600' : 'bg-gray-200 dark:bg-gray-800 ' + bgColor, disabled ? 'contrast-50 !cursor-not-allowed' : 'contrast-100']">
                <span
                    :class="[model ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out']">
                    <span
                        :class="[model ? 'opacity-0 duration-100 ease-out' : 'opacity-100 duration-200 ease-in', 'absolute inset-0 flex h-full w-full items-center justify-center transition-opacity']"
                        aria-hidden="true">
                        <Icon
                            v-if="icons"
                            :name="icons[0]"
                            class="h-4 w-4 text-gray-600" />
                    </span>
                    <span
                        :class="[model ? 'opacity-100 duration-200 ease-in' : 'opacity-0 duration-100 ease-out', 'absolute inset-0 flex h-full w-full items-center justify-center transition-opacity']"
                        aria-hidden="true">
                        <Icon
                            v-if="icons"
                            :name="icons[1]"
                            class="h-4 w-4 text-gray-600" />
                    </span>
                </span>
            </Switch>
            <label
                v-if="label"
                :for="name"
                class="ml-2 text-gray-700 dark:text-gray-200 text-sm leading-6 flex flex-col">
                <span :class="{'font-semibold' : model}">{{ label }}</span>
                <span
                    v-if="description"
                    class="text-gray-500 dark:text-gray-400">{{ description }}</span>
            </label>
            <BasePopover
                v-if="helpText"
                size="sm"
                popover-wrapper-classes="self-center"
                position="left">
                <template #trigger>
                    <div class="flex items-center">
                        <Icon
                            name="heroicons:question-mark-circle"
                            class="h-5 w-5 text-primary-500 hover:bg-primary-500 hover:text-white hover:rounded-full" />
                    </div>
                </template>
                <template #default>
                    <span
                        class="text-neutral-500 dark:text-gray-300 mt-2"
                        v-html="helpText" />
                </template>
            </BasePopover>
        </div>
    </BaseInput>
</template>

<script setup lang="ts">
const emit = defineEmits(['update:modelValue'])
const props = defineProps<{
    modelValue: boolean | Number,
    name: string,
    description?: string,
    disabled?: boolean,
    icons?: [string, string],
    label?: string,
    bgColor?: string,
    helpText?: string,
}>()

const model = computed({
    get() {
        return !!props.modelValue
    },
    set(value) {
        emit('update:modelValue', value)
    }
})

</script>